import React, { useContext, useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import { Row, Dropdown, Button, ButtonGroup, Alert } from "react-bootstrap";
import { MdErrorOutline } from "react-icons/md";

import { Task, Settings } from "../../helpers/Contexts";

const SaveTaskButtons = ({ saveTask, data }) => {
  const [showAlert, setShowAlert] = useState(false);

  const { taskValues, setTaskValues } = useContext(Task);
  const settings = useContext(Settings);

  const disabled = false;

  const showClose =
    data.status == "closed" ||
    (data.cpr == "closed-completed_results_obtained" &&
      taskValues.checked.qm &&
      taskValues.checked.cpr &&
      taskValues.checked.conditions)
      ? true
      : false;

  const StatusDropdown = () => (
    <Dropdown.Menu id="submit-task" className="buttons">
      <Dropdown.Item onClick={() => saveTask("open")}>Save as Open</Dropdown.Item>
      <Dropdown.Item onClick={() => saveTask("pending")}>Save as On Hold</Dropdown.Item>
      <Dropdown.Item onClick={() => saveTask("closed")}>Save as Closed</Dropdown.Item>
    </Dropdown.Menu>
  );

  function renderMenu() {
    return settings.me.support_agent_type == "Admin" ? (
      <StatusDropdown />
    ) : !disabled && !showClose ? (
      <StatusDropdown />
    ) : null;
  }

  return (
    <>
      <Row id="task-buttons">
        {showAlert && (
          <Alert className={"alert"} variant="danger">
            <MdErrorOutline className="error-icon" />
            {data.status == "open" && "It looks like you are still working on this task... "}
            {data.cpr == "closed-completed_results_obtained" &&
              data.status == "open" &&
              "Complete task outcomes & data entry to continue"}
            {data.status == "closed" &&
              settings.me.support_agent_type !== "Admin" &&
              "Task is now closed. Contact a wellPORTAL admin to re-open this task"}
          </Alert>
        )}
        <ButtonGroup>
          {!showClose && (
            <Button
              onMouseEnter={() => {
                disabled && setShowAlert(true);

                setTimeout(() => {
                  showAlert ? setShowAlert(false) : null;
                }, 10000);
              }}
              as={ButtonGroup}
              disabled={disabled}
              id="submit-task"
              onClick={() => {
                data.status == "open" ? saveTask("open") : saveTask("pending");
              }}
              className={disabled ? "disabled" : data.status == "open" ? "" : "hold"}
            >
              Save as {data.status == "open" ? " Open" : " On Hold"}
            </Button>
          )}

          {showClose && (
            <Button
              onMouseEnter={() => {
                disabled && setShowAlert(true);
                setTimeout(() => {
                  setShowAlert(false);
                }, 5500);
              }}
              as={ButtonGroup}
              disabled={disabled}
              id="submit-task closed"
              onClick={() => saveTask("closed")}
              className={disabled ? "disabled" : ""}
            >
              {"Save as Closed"}
            </Button>
          )}

          {showClose ? (
            <Button
              disabled={disabled}
              as={Dropdown}
              id="submit-task closed dropdown"
              className={disabled ? "disabled" : ""}
            >
              <Dropdown.Toggle
                as={ButtonGroup}
                disabled={disabled}
                className={disabled ? "disabled" : ""}
                id="submit-task dropdown-autoclose-true"
              >
                <FiChevronDown className="submit-down-icon" />
              </Dropdown.Toggle>
              {renderMenu()}
            </Button>
          ) : (
            <Button
              disabled={disabled}
              as={Dropdown}
              id="submit-task dropdown"
              className={disabled ? "disabled" : data.status == "open" ? "" : "hold"}
            >
              <Dropdown.Toggle
                as={ButtonGroup}
                disabled={disabled}
                className={disabled ? "disabled" : ""}
                id="submit-task dropdown-autoclose-true"
              >
                <FiChevronDown className="submit-down-icon" />
              </Dropdown.Toggle>
              {renderMenu()}
            </Button>
          )}
        </ButtonGroup>
      </Row>
    </>
  );
};
export default SaveTaskButtons;
